module.exports = __webpack_public_path__ + "static/media/Wedding.d86ed4c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Wedding.png
// module id = 1341
// module chunks = 3